import { useDisclosure } from "@chakra-ui/react";

export const useSSLErrorHandler = () => {
  const sslHelperDisclosure = useDisclosure();

  const handleError = () => false;
  const clearSSLError = () => {
    sslHelperDisclosure.onClose();
  };

  return {
    sslError: null,
    sslHelperDisclosure,
    handleError,
    clearSSLError,
  };
};
